import { render, staticRenderFns } from "./FoldButton.vue?vue&type=template&id=17ebd939&scoped=true&"
import script from "./FoldButton.vue?vue&type=script&lang=js&"
export * from "./FoldButton.vue?vue&type=script&lang=js&"
import style0 from "./FoldButton.vue?vue&type=style&index=0&id=17ebd939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ebd939",
  null
  
)

export default component.exports